module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns-house_access_03-6da40bf72b1bc179660613b67ba49492.jpg";